import { Ticket, TicketDraft } from '../types/ticket'
import { ticketPeople } from '../data/ticketOptions'

type Listener = () => void

function seedTickets(): Ticket[] {
  return Array.from({ length: 50 }, (_, i) => {
    const isCompany = i % 3 !== 2
    return {
      id: String(i + 1),
      code: `TKT-2024/${String(i + 1).padStart(3, '0')}`,
      createdBy: ticketPeople[(i + 1) % ticketPeople.length],
      recipient: ticketPeople[i % ticketPeople.length],
      cc: i % 2 === 0 ? [ticketPeople[(i + 2) % ticketPeople.length]] : [],
      scope: isCompany ? 'Azienda' : 'Interno',
      client: isCompany ? `Azienda ${i} SRL` : '',
      description:
        i % 2 === 0
          ? 'Errore nella fatturazione del mese corrente'
          : 'Richiesta di nuova offerta per rinnovo servizi',
      channel: i % 3 === 0 ? 'Urgente' : 'Standard',
      deadline: `2024-06-${String((i % 28) + 1).padStart(2, '0')}`,
      status: i % 3 === 0 ? 'Aperto' : i % 3 === 1 ? 'Sospeso' : 'Chiuso',
      notes: '',
      date: '2024-05-20',
      comments: [
        {
          user: ticketPeople[i % ticketPeople.length],
          text: 'Preso in carico',
          date: '2024-05-20 10:00',
        },
      ],
    }
  })
}

class TicketsStore {
  private tickets: Ticket[] = seedTickets()
  private listeners = new Set<Listener>()

  getAll(): Ticket[] {
    return this.tickets
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }

  add(draft: TicketDraft): Ticket {
    const nextNumber =
      this.tickets.reduce((max, t) => Math.max(max, Number(t.id)), 0) + 1
    const ticket: Ticket = {
      ...draft,
      id: String(nextNumber),
      code: `TKT-${new Date().getFullYear()}/${String(nextNumber).padStart(3, '0')}`,
      date: new Date().toISOString().split('T')[0],
      comments: [],
    }
    this.tickets = [ticket, ...this.tickets]
    this.emit()
    return ticket
  }

  update(id: string, changes: Partial<TicketDraft>): void {
    this.tickets = this.tickets.map((t) =>
      t.id === id ? { ...t, ...changes } : t,
    )
    this.emit()
  }

  remove(id: string): void {
    this.tickets = this.tickets.filter((t) => t.id !== id)
    this.emit()
  }

  private emit() {
    this.listeners.forEach((l) => l())
  }
}

export const ticketsStore = new TicketsStore()
